import { http } from '@/lib/http';
import type { IAlertsPage } from './alert.types';

// `operator-bff:GET /v1/alerts@v1` + `POST /v1/alerts/read@v1` (brief §7.4) through the
// console's one configured ky instance (auth, traceparent, 401 handling). The read is a
// CATCH-UP, never a poll: the host calls it once per socket reconnect and once per return
// from away (frontend-conventions §8.1 / §15.10) — see `catchUp` in alerts.store.ts.

/** The list cap: one catch-up never brings more than the console keeps. */
export const CATCH_UP_LIMIT = 50;

export function getAlerts(since: string, limit = CATCH_UP_LIMIT): Promise<IAlertsPage> {
  return http.get('v1/alerts', { searchParams: { since, limit } }).json<IAlertsPage>();
}

/** Move the operator's read cursor (server-side, per operator — every tab and device). */
export async function readAlerts(upTo: string): Promise<void> {
  await http.post('v1/alerts/read', { json: { upTo } });
}
